import { storyblokEditable } from "@storyblok/react";

const SoloImage = ({ blok }) => {
  return (

      <img src={blok.image.filename} alt={blok.image.alt} />


  );
};

export default SoloImage;
